// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1i5jC","emails":"CreateEditClinics_emails__jBrWp","emailTagLabel":"CreateEditClinics_emailTagLabel___1tPI"};